enum TaskSendEmailType {
    StatusChange = 1,
    RegisterAssignedTo = 2,
    AssignedToChange = 3,
    NewComment = 4,
    NewCommentAssignedTo = 5,
    StatusChangeObserver = 6
}

export default TaskSendEmailType;